import { ButtonHTMLAttributes } from 'react';
import styled from '@emotion/styled';
import { themed, ITheme } from '../../themer';

export interface IBaseButtonProps
	extends ButtonHTMLAttributes<HTMLButtonElement> {
	inverted?: boolean;
	invertedSecondary?: boolean;
	secondary?: boolean;
	textButton?: boolean;
}

export const Base = styled.button<IBaseButtonProps, ITheme>`
	outline: 2px solid transparent;
	cursor: pointer;
	border-radius: ${themed(({ button }) => button.radius)};
	padding: ${themed(({ button }) => button.padding)};
	height: ${themed(({ button }) => button.height)};
	line-height: ${themed(({ button }) => button.lineHeight)};
	gap: ${themed(({ button }) => button.iconSeparator)};

	a {
		display: block;
		text-decoration: none;
	}
`;
